import { useEffect, useState } from 'react';

import { LightTable } from '../../../../../components/index';
import {
  OperationProductTypeDescription,
  StorageSumaryItemType,
} from '../../../../../types';
import { solidBulkStorageSummaryTableColumns } from './solidBulkStorageSummaryTableColumns';

type SolidBulkStorageSummaryTableProps = {
  product: OperationProductTypeDescription;
};
export function SolidBulkStorageSummaryTable(
  props: SolidBulkStorageSummaryTableProps
) {
  const { product } = props;
  const [
    operationProductStorageSummaryData,
    setOperationProductStorageSummaryData,
  ] = useState<StorageSumaryItemType[]>([]);
  useEffect(() => {
    if (product && product.storage_summary) {
      setOperationProductStorageSummaryData(
        Object.keys(product.storage_summary).map(
          (storageSummaryId: string, index: number) => {
            return {
              ...product.storage_summary[parseInt(storageSummaryId, 10)],
              key: index,
            };
          }
        )
      );
    }
  }, [product]);
  return (
    <LightTable
      columns={solidBulkStorageSummaryTableColumns()}
      dataSource={operationProductStorageSummaryData}
      className="read-only"
      pagination={false}
    />
  );
}
